import React from "react"
import Drawer from "@kit/design/drawer"
import { NotificationsList } from "./notifications-list"

export function BulkNotificationsDrawer({ open, onClose, topics }) {
  if (!open) return null

  return (
    <Drawer heading="Notifications" onClose={onClose} label="Notifications">
      <NotificationsList topics={topics} />
    </Drawer>
  )
}
